// extracted by mini-css-extract-plugin
module.exports = {"product-brief-guide-popup":"Popup_product-brief-guide-popup__iEArZ"};